import React from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const SuccessStoriesPage = () => {
  const agencyStories = [
    {
      name: "Global Scholars Overseas Consultancy",
      location: "Hyderabad & Bangalore",
      volume: "Scaled from 120 to 450 admissions/year",
      results: "+275% Revenue Growth in 12 Months",
      story: "Before EdOps, our counsellors spent 60% of their time manually looking up university entry criteria and writing SOPs. By adopting EdOps AI Shortlisting and CRM, our application filing speed quadrupled and agency revenues tripled!",
      img: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=300&q=80"
    },
    {
      name: "Apex Study Abroad Agency Network",
      location: "Delhi, Mumbai & Pune",
      volume: "Multi-branch franchise managing 1,200+ students",
      results: "100% Commission Audit & Zero Leakage",
      story: "Managing commissions across 14 regional sub-agents was a financial nightmare. EdOps Commission & Financial Engine automated our payout structures, loan referral tracking, and branch permissions seamlessly.",
      img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=300&q=80"
    },
    {
      name: "NextGen Overseas Education Franchise",
      location: "Chennai & Kochi",
      volume: "350+ UK & Canada Admissions Processed",
      results: "98.5% Visa Approval SLA",
      story: "The EdOps 100% Student Visa Operations module gave our counsellors automated CAS/I-20 tracking and simulated mock visa interview prep tools. Our student visa rejection rate dropped to near zero!",
      img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=300&q=80"
    },
  ];

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Banner */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Agency Case Studies</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Consultancy Success Stories</h1>
          <p className="consultancy-lead-text mx-auto" style={{ maxWidth: "650px" }}>
            Discover how leading overseas education agencies, study abroad franchises, and admission partners use EdOps Global to scale their business operations.
          </p>
        </div>
      </section>

      {/* Case Studies Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {agencyStories.map((s, idx) => (
            <div key={idx} className="col-lg-4 col-md-6">
              <div className="consultancy-glass-card p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <img src={s.img} alt={s.name} className="rounded-circle" style={{ width: "60px", height: "60px", objectFit: "cover", border: "2px solid var(--consultancy-gold-primary)" }} />
                    <div>
                      <h5 className="font-weight-bold consultancy-gold-title mb-0">{s.name}</h5>
                      <small className="text-muted d-block">{s.location}</small>
                    </div>
                  </div>

                  <div className="consultancy-pill-card mb-3 small">
                    <div className="mb-1">
                      <span className="text-muted">Volume Growth:</span>
                      <strong className="text-white d-block">{s.volume}</strong>
                    </div>
                    <div>
                      <span className="text-muted">Key Result:</span>
                      <strong className="text-warning d-block">{s.results}</strong>
                    </div>
                  </div>

                  <p className="text-muted small" style={{ lineHeight: "1.7" }}>"{s.story}"</p>
                </div>

                <div className="pt-3 text-warning small font-weight-bold text-center" style={{ borderTop: "1px solid rgba(212, 175, 55, 0.12)" }}>
                  <i className="fas fa-check-circle mr-1"></i> Verified Agency Client Case Study
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5 pt-3">
          <Link to="/consultancy/book-consultation" className="consultancy-btn-gold px-5 py-3">
            Schedule Agency Platform Demo <i className="fas fa-arrow-right ml-1"></i>
          </Link>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default SuccessStoriesPage;
